import React from 'react'
import PropTypes from 'prop-types'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantTable from '@nexidigital/merchanttable'
import formattedMessage from './languageModule'
import { formatCurrency, formatThousands } from 'Utility/globalMethods'
import './ClientsDetail.scss'

const ClientSecondPeriodDetail = ({ referredPeriod, recurringClients, newClients }) => {
  const renderClientBox = (title, clientData) => {
    const { customersCount, transactionsCount, transactionsCost, transactionsPerPans = [] } = clientData || {}
    const hasTransactions = Array.isArray(transactionsPerPans) && transactionsPerPans.length > 0

    return (
      <MerchantGenericCard title={title}>
        <div className='keyIndicatorClients'>
          <div className='keyIndicatorRow'>
            <div className='keyIndicatorLabel'>{formattedMessage.clientNumber}</div>
            <div className='keyIndicatorValue'>{customersCount ?? '0'}</div>
          </div>
          <div className='keyIndicatorRow'>
            <div className='keyIndicatorLabel'>{formattedMessage.transactions}</div>
            <div className='keyIndicatorValue'>{transactionsCount ? formatThousands(transactionsCount) : '0'}</div>
          </div>
          <div className='keyIndicatorRow'>
            <div className='keyIndicatorLabel'>{formattedMessage.transacted}</div>
            <div className='keyIndicatorValue'>{transactionsCost ? `${formatCurrency(transactionsCost)}` : '0 €'}</div>
          </div>
        </div>

        {hasTransactions && (
          <div className='tableClientsDetail'>
            <MerchantTable
              name='merchantPortal'
              tabIndex={-1}
              columns={[
                { id: 'paymentMethod', label: formattedMessage.payment, sx: { width: '33.33%' } },
                { id: 'transaction', label: formattedMessage.transactions, align: 'right', sx: { width: '33.33%' } },
                { id: 'transacted', label: formattedMessage.transacted, align: 'right', sx: { width: '33.33%' } }
              ]}
              onPagination={() => { }}
              onSort={() => { }}
              rows={transactionsPerPans.map(row => ({
                paymentMethod: row?.pan ? `**** ${row.pan}` : '0',
                transaction: <b>{row?.transactionCount ? formatThousands(row.transactionCount) : '0'}</b>,
                transacted: <b>{row?.transactionCost ? `${formatCurrency(row.transactionCost)}` : '0 €'}</b>
              }))}
              sx={{ border: '0' }}
            />
          </div>
        )}
      </MerchantGenericCard>
    )
  }

  return (
    <div className='clientsDetailPeriodDetail'>
      <div className='clientsDetailPeriodDates'>
        <p>{formattedMessage.period}</p>
        <MerchantTableBadge label={referredPeriod?.[2] ?? '-'} status='neutralLight' /> -
        <MerchantTableBadge label={referredPeriod?.[3] ?? '-'} status='neutralLight' />
      </div>
      <div className='clientsPeriodContent'>
        {renderClientBox(formattedMessage.recurringClients, recurringClients)}
        {renderClientBox(formattedMessage.newClient, newClients)}
      </div>
    </div>
  )
}

ClientSecondPeriodDetail.propTypes = {
  referredPeriod: PropTypes.arrayOf(PropTypes.string),
  recurringClients: PropTypes.shape({
    customersCount: PropTypes.number,
    transactionsCount: PropTypes.number,
    transactionsCost: PropTypes.number,
    transactionsPerPans: PropTypes.arrayOf(PropTypes.shape({
      pan: PropTypes.string,
      transactionCount: PropTypes.number,
      transactionCost: PropTypes.number
    }))
  }),
  newClients: PropTypes.shape({
    customersCount: PropTypes.number,
    transactionsCount: PropTypes.number,
    transactionsCost: PropTypes.number,
    transactionsPerPans: PropTypes.arrayOf(PropTypes.shape({
      pan: PropTypes.string,
      transactionCount: PropTypes.number,
      transactionCost: PropTypes.number
    }))
  })
}

ClientSecondPeriodDetail.defaultProps = {
  referredPeriod: ['-', '-'],
  recurringClients: { customersCount: 0, transactionsCount: 0, transactionsCost: 0, transactionsPerPans: [] },
  newClients: { customersCount: 0, transactionsCount: 0, transactionsCost: 0, transactionsPerPans: [] }
}

export default ClientSecondPeriodDetail
